var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9291 25.0923C30.2587 25.0923 33.7684 21.5825 33.7684 17.253C33.7684 12.9234 30.2587 9.41367 25.9291 9.41367C21.5996 9.41367 18.0898 12.9234 18.0898 17.253C18.0898 21.5825 21.5996 25.0923 25.9291 25.0923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6077 29.5718C44.7002 29.5718 47.2072 27.0648 47.2072 23.9723C47.2072 20.8798 44.7002 18.3729 41.6077 18.3729C38.5152 18.3729 36.0083 20.8798 36.0083 23.9723C36.0083 27.0648 38.5152 29.5718 41.6077 29.5718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.41 29.5718C13.5025 29.5718 16.0094 27.0648 16.0094 23.9723C16.0094 20.8798 13.5025 18.3729 10.41 18.3729C7.3175 18.3729 4.81055 20.8798 4.81055 23.9723C4.81055 27.0648 7.3175 29.5718 10.41 29.5718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9293 27.332C17.9018 27.332 11.3706 33.8633 11.3706 41.8907C11.3706 42.5089 11.8724 43.0106 12.4905 43.0106H39.368C39.9862 43.0106 40.4879 42.5089 40.4879 41.8907C40.4879 33.8633 33.9567 27.332 25.9293 27.332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3406 32.0535C11.6553 31.9079 10.9587 31.8116 10.2509 31.8116C4.69401 31.8116 0.171875 36.3337 0.171875 41.8907C0.171875 42.5088 0.673622 43.0106 1.2918 43.0106H9.33709C9.21162 42.659 9.13099 42.2849 9.13099 41.8907C9.13099 38.2152 10.3316 34.8219 12.3406 32.0535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6078 31.8116C40.9 31.8116 40.2034 31.9079 39.5181 32.0535C41.5272 34.8219 42.7277 38.2152 42.7277 41.8907C42.7277 42.2849 42.6471 42.6589 42.5216 43.0106H50.5669C51.1851 43.0106 51.6868 42.5088 51.6868 41.8907C51.6868 36.3337 47.1647 31.8116 41.6078 31.8116Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.5152,
    height: 51.5152,
    fill: "white",
    transform: "translate(0.171875 0.454559)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.fe0869507988391bc1c72ac6156e638d.svg";
export { ForwardRef as ReactComponent };